<template>
  <div class="popup_in">
    <div class="popup">
      <h2 v-if="title" class="title title--40 title--spacing">{{ title }}</h2>
      <div v-if="content" class="popup-content">{{ content }}</div>
      <div class="flex flex--center flex--content--center gap--5">
        <a
          class="bt_blue"
          href="javascript:void(0)"
          @click.prevent="handleYes"
          >{{ yesText }}</a
        >
        <a
          class="bt_blue"
          href="javascript:void(0)"
          @click.prevent="handleNo"
          >{{ noText }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditionalPlannedSurgeryCode",
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    yesText: {
      type: String,
      default: "כן"
    },
    noText: {
      type: String,
      default: "לא"
    },
    onYes: {
      type: Function,
      required: true
    }
  },
  methods: {
    async handleYes() {
      const ok = await this.onYes();
      if (ok !== false) this.$emit("close");
    },
    async handleNo() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.popup-content {
  margin-bottom: 30px;
}

.title--spacing {
  margin-bottom: 30px;
}
</style>
